import {useState, useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import Style from './style'
import close from './asset/close.svg'

import DefaultSlideModal from 'shared/ui/DefaultSlideModal'
import DefaultButton from 'shared/ui/DefaultButton'
import {
	OFFICIAL,
	PRELIMINARY,
	STORE,
	TRYOUT,
	FREEROLL,
	convertEventTypeAsName,
} from 'shared/constant/lookup/eventType'
import {
	READY,
	REGISTER,
	TAKING,
	END,
	PAUSE,
	convertEventStateAsName,
} from 'shared/constant/lookup/eventState'
import {todayCalculator, paddedCalculator} from 'shared/lib/todayCalculator'

const getMaxDay = (y, m) => new Date(y, m, 0).getDate()

const FilterModal = ({closeEvent}) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const parseMultiParam = (key) =>
		searchParams
			.getAll(key)
			.flatMap((value) => value.split(','))
			.filter(Boolean)

	const eventTypeFlag = parseMultiParam('eventTypeFlag')
	const eventStateFlag = parseMultiParam('eventStateFlag')
	const startDateTime = searchParams.get('startDateTime')
	const endDateTime = searchParams.get('endDateTime')

	const [year, month, day] = todayCalculator()

	const [tabType, setTabType] = useState(null)
	const [levelFlag, setLevelFlag] = useState(
		eventTypeFlag.length > 0 ? eventTypeFlag : [OFFICIAL.toString()]
	)
	const [stateFlag, setStateFlag] = useState(
		eventStateFlag.length > 0 ? eventStateFlag : [REGISTER.toString(), TAKING.toString()]
	)
	const [startDate, setStartDate] = useState(
		startDateTime ||
			`${year}-${paddedCalculator(month)}-${paddedCalculator(day)}`
	)
	const [endDate, setEndDate] = useState(
		endDateTime || `${year}-${paddedCalculator(month)}-${paddedCalculator(day)}`
	)

	// 필터링 적용 이벤트
	const applyFilterEvent = () => {
		closeEvent()
		searchParams.set('eventTypeFlag', levelFlag.join(','))
		searchParams.set('eventStateFlag', stateFlag.join(','))
		searchParams.set('startDateTime', startDate)
		searchParams.set('endDateTime', endDate)
		setSearchParams(searchParams)
	}

	const toggleLevel = (idx) => {
			setLevelFlag((prev) =>
				prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
			)
		}

		const toggleState = (idx) => {
			setStateFlag((prev) =>
				prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
			)
		}

	const updateDate = (type, data, current, setDate) => {
		const dateSplit = current.split('-')
		switch (type) {
			case 'year':
				dateSplit[0] = data.toString()
				break
			case 'month':
				dateSplit[1] = paddedCalculator(data)
				break
			case 'day':
				dateSplit[2] = paddedCalculator(data)
				break
		}
		const max = getMaxDay(parseInt(dateSplit[0]), parseInt(dateSplit[1]))
		if (parseInt(dateSplit[2]) > max) dateSplit[2] = paddedCalculator(max)
		setDate(`${dateSplit[0]}-${dateSplit[1]}-${dateSplit[2]}`)
	}

	const prevDay = (date, setDate) => {
		const parts = date.split('-').map(Number)
		const max = getMaxDay(parts[0], parts[1])
		updateDate('day', parts[2] === 1 ? max : parts[2] - 1, date, setDate)
	}

	const nextDay = (date, setDate) => {
		const parts = date.split('-').map(Number)
		const max = getMaxDay(parts[0], parts[1])
		updateDate('day', parts[2] === max ? 1 : parts[2] + 1, date, setDate)
	}

	return (
		<DefaultSlideModal title='필터링' closeEvent={closeEvent}>
			{!tabType && (
				<>
					<Style.FilterElement>
						<h2>대회 등급</h2>
						<Style.ElementList>
							{[OFFICIAL, PRELIMINARY, STORE, TRYOUT, FREEROLL].map((elem) => (
								<Style.Element
									onClick={() => toggleLevel(elem.toString())}
									$active={levelFlag.includes(elem.toString())}
								>
									{convertEventTypeAsName[elem]}
								</Style.Element>
							))}
						</Style.ElementList>
					</Style.FilterElement>

					<Style.FilterElement>
						<h2>대회 상태</h2>
						<Style.ElementList>
							{[READY, REGISTER, TAKING, PAUSE, END].map((elem) => (
								<Style.Element
									onClick={() => toggleState(elem.toString())}
									$active={stateFlag.includes(elem.toString())}
								>
									{convertEventStateAsName[elem]}
								</Style.Element>
							))}
						</Style.ElementList>
					</Style.FilterElement>

					<Style.FilterElement>
						<h2>조회 기간</h2>
						<Style.DurationList>
							<Style.Duration onClick={() => setTabType('시작')}>
								{startDate}
							</Style.Duration>
							<p>~</p>
							<Style.Duration onClick={() => setTabType('종료')}>
								{endDate}
							</Style.Duration>
						</Style.DurationList>
					</Style.FilterElement>

					<DefaultButton clickEvent={applyFilterEvent}>적용</DefaultButton>
				</>
			)}

			{tabType === '시작' && (
				<>
					<Style.FilterElement>
						<h2>시작 날짜</h2>
						<Style.DateList>
							<Style.DateDiv>
								<button
									onClick={() =>
										updateDate(
											'year',
											parseInt(startDate.split('-')[0]) - 1,
											startDate,
											setStartDate
										)
									}
								>
									{parseInt(startDate.split('-')[0]) - 1}년
								</button>
								<button
									onClick={() =>
										updateDate(
											'month',
											parseInt(startDate.split('-')[1]) === 1
												? 12
												: parseInt(startDate.split('-')[1]) - 1,
											startDate,
											setStartDate
										)
									}
								>
									{parseInt(startDate.split('-')[1]) === 1
										? 12
										: parseInt(startDate.split('-')[1]) - 1}
									월
								</button>
								<button onClick={() => prevDay(startDate, setStartDate)}>
									{(() => {
										const p = startDate.split('-').map(Number)
										const max = getMaxDay(p[0], p[1])
										return p[2] === 1 ? max : p[2] - 1
									})()}
									일
								</button>
							</Style.DateDiv>
							<Style.DateDiv $highlight>
								<p>{startDate.split('-')[0]}년</p>
								<p>{parseInt(startDate.split('-')[1])}월</p>
								<p>{parseInt(startDate.split('-')[2])}일</p>
							</Style.DateDiv>
							<Style.DateDiv>
								<button
									onClick={() =>
										updateDate(
											'year',
											parseInt(startDate.split('-')[0]) + 1,
											startDate,
											setStartDate
										)
									}
								>
									{parseInt(startDate.split('-')[0]) + 1}년
								</button>
								<button
									onClick={() =>
										updateDate(
											'month',
											parseInt(startDate.split('-')[1]) === 12
												? 1
												: parseInt(startDate.split('-')[1]) + 1,
											startDate,
											setStartDate
										)
									}
								>
									{parseInt(startDate.split('-')[1]) === 12
										? 1
										: parseInt(startDate.split('-')[1]) + 1}
									월
								</button>
								<button onClick={() => nextDay(startDate, setStartDate)}>
									{(() => {
										const p = startDate.split('-').map(Number)
										const max = getMaxDay(p[0], p[1])
										return p[2] === max ? 1 : p[2] + 1
									})()}
									일
								</button>
							</Style.DateDiv>
						</Style.DateList>
					</Style.FilterElement>

					<DefaultButton clickEvent={() => setTabType(null)}>
						확인
					</DefaultButton>
				</>
			)}

			{tabType === '종료' && (
				<>
					<Style.FilterElement>
						<h2>종료 날짜</h2>
						<Style.DateList>
							<Style.DateDiv>
								<button
									onClick={() =>
										updateDate(
											'year',
											parseInt(endDate.split('-')[0]) - 1,
											endDate,
											setEndDate
										)
									}
								>
									{parseInt(endDate.split('-')[0]) - 1}년
								</button>
								<button
									onClick={() =>
										updateDate(
											'month',
											parseInt(endDate.split('-')[1]) === 1
												? 12
												: parseInt(endDate.split('-')[1]) - 1,
											endDate,
											setEndDate
										)
									}
								>
									{parseInt(endDate.split('-')[1]) === 1
										? 12
										: parseInt(endDate.split('-')[1]) - 1}
									월
								</button>
								<button onClick={() => prevDay(endDate, setEndDate)}>
									{(() => {
										const p = endDate.split('-').map(Number)
										const max = getMaxDay(p[0], p[1])
										return p[2] === 1 ? max : p[2] - 1
									})()}
									일
								</button>
							</Style.DateDiv>
							<Style.DateDiv $highlight>
								<p>{endDate.split('-')[0]}년</p>
								<p>{parseInt(endDate.split('-')[1])}월</p>
								<p>{parseInt(endDate.split('-')[2])}일</p>
							</Style.DateDiv>
							<Style.DateDiv>
								<button
									onClick={() =>
										updateDate(
											'year',
											parseInt(endDate.split('-')[0]) + 1,
											endDate,
											setEndDate
										)
									}
								>
									{parseInt(endDate.split('-')[0]) + 1}년
								</button>
								<button
									onClick={() =>
										updateDate(
											'month',
											parseInt(endDate.split('-')[1]) === 12
												? 1
												: parseInt(endDate.split('-')[1]) + 1,
											endDate,
											setEndDate
										)
									}
								>
									{parseInt(endDate.split('-')[1]) === 12
										? 1
										: parseInt(endDate.split('-')[1]) + 1}
									월
								</button>
								<button onClick={() => nextDay(endDate, setEndDate)}>
									{(() => {
										const p = endDate.split('-').map(Number)
										const max = getMaxDay(p[0], p[1])
										return p[2] === max ? 1 : p[2] + 1
									})()}
									일
								</button>
							</Style.DateDiv>
						</Style.DateList>
					</Style.FilterElement>

					<DefaultButton clickEvent={() => setTabType(null)}>
						확인
					</DefaultButton>
				</>
			)}
		</DefaultSlideModal>
	)
}

export default FilterModal
